import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { StyledUploadBox } from "../../uploadDocument";
import { MdCloudUpload } from "react-icons/md";
import { LoadingButton } from "@mui/lab";
import { SerasaService } from "../../../services/serasa";
import { LineComponent } from "../../../components/line";
import { Timer } from "../../../components/timer";
import useAuth from "../../../context/auth";
import { getTimeRemainingUntilCancellation } from "../../../utils";

export const UploadSerasaDocument = () => {
    const { palette } = useTheme()
    const { user, getData } = useAuth()
    const navigate = useNavigate()

    const [documentFile, setDocumentFile] = useState<null | File>(null)
    const [loading, setLoading] = useState(false)

    const timeRemaining = getTimeRemainingUntilCancellation(user?.actualContract?.contract?.createdAt as string)

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        if (file) {
            console.log("Arquivo selecionado:", file)
            setDocumentFile(file)
        }
    }

    const handleBoxClick = () => {
        const input = document.getElementById("upload-input") as HTMLInputElement
        if (input) {
            input.click()
        }
    }

    const uploadDocument = () => {
        setLoading(true)
        SerasaService.uploadDocument(documentFile as File)
            .then(() => navigate("/cliente/pedido-enviado"))
            .catch(() => setLoading(false))
    }

    return (
        <>
            <Typography fontWeight={700} fontSize={"2.6rem"} p={0}>
                Estamos quase lá!
            </Typography>

            <Typography
                fontWeight={400}
                fontSize={"1.6rem"}
                sx={{ color: "gray" }}
                p={0}
                mb={2}
                textAlign={"justify"}
            >
                Para dar continuidade em sua análise é necessário que você clique no botão abaixo para consultar as pendências do seu CPF no site oficial <strong>CONSULTA SERASA</strong> e nos envie o <strong>PRINT DA TELA “PENDÊNCIAS”</strong>.
            </Typography>

            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} sx={{ bgcolor: "rgba(1,1,1,0.1)" }} p={2} borderRadius={2}>
                <Typography>Tempo restante para envio:</Typography>
                <Timer
                    hours={timeRemaining}
                    onTimerZero={async () => {
                        await getData()
                        navigate("cliente")
                    }}
                    format="MMm SSs"
                    withDelay={5}
                />
            </Box>

            <Typography
                fontWeight={600}
                fontSize={"1.6rem"}
                sx={{ textAlign: "center" }}
                p={0}
                mb={2}
            >
                Passo a Passo - Saiba como ter acesso à consulta SERASA
            </Typography >


            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>1° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Clique nesse botão abaixo</Typography>
            <Link to={"https://www.serasa.com.br/area-cliente/meu-cpf/pendencias"} target="_blank">
                <Button variant="contained" sx={{ width: "100%", animation: "pulse 2s infinite" }}>Clique aqui para CONSULTA SERASA - CPF</Button>
            </Link>
            <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>2° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Após clicar no botão, abrirá uma página de consultas SERASA, informe seus dados solicitados para você acessar a página  consultas SERASA</Typography>
            <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>3° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Ao acessar a página consultas SERASA, faça um PRINT DA TELA “Pendências”, anexe o PRINT no espaço abaixo e clique em enviar </Typography>
            <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

            <StyledUploadBox onClick={handleBoxClick}>
                <MdCloudUpload size={52} color={palette.primary.main} />

                <Typography fontSize={"1.6rem"} sx={{ opacity: .5 }} textAlign={"center"}>
                    {documentFile && documentFile.name}
                    {!documentFile && <>Anexe aqui o print da tela PENDÊNCIAS<br />(.jpg .jpeg .png .pdf)</>}
                </Typography>

                {documentFile &&
                    <Typography fontWeight={500} fontSize={"1.6rem"} sx={{ textDecoration: "underline", opacity: 0.5 }}>
                        Se prefefir, substitua o arquivo
                    </Typography>
                }

                <input
                    id="upload-input"
                    type="file"
                    style={{ display: "none" }}
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={handleFileChange}
                />
            </StyledUploadBox>

            <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                flexDirection={"column"}
            >
                <LoadingButton
                    variant="contained"
                    disabled={!documentFile || loading}
                    loading={loading}
                    sx={{
                        height: "5rem",
                        ... (!(!documentFile || loading) && {
                            animation: "pulse 1.5s infinite"
                        })
                    }}
                    onClick={uploadDocument}
                >
                    Enviar
                </LoadingButton>
            </Grid>

        </>
    )
}
